module.exports = __webpack_public_path__ + "static/1-asset-1-d@3x-9eb736edbaf67741d4889edce9cc1181.png";